//import jwtDecode from "jwt-decode";
import http from "./httpService";
import { apiUrl } from "../config.json";


const apiEndpoint = apiUrl + "/token";

const tokenKey = "token";

http.setJwt(getJwt());

export async function login(email = '', password) {



  var data = "password=" + password + "&username=" + email.replace("@", "%40") + "&grant_type=password";

  // const config = {
  //   headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // }
  // }
  const { data: jwt } = await http.post(apiEndpoint, data);
  // const {  data: jwtApp} = await http.post(appToken, data  );
  //const userinfo=    firebase.auth().signInWithEmailAndPassword(data.username,data.password);
  // console.log(userinfo);
  //  localStorage.setItem("userId",JSON.stringify(userinfo));

  if (email === "adib@salmustasharak.com" || "mohannad@salmustasharak.com") {
    localStorage.setItem(tokenKey, jwt.access_token);
    // localStorage.setItem("tokenApp",jwtApp.access_token );
    localStorage.setItem("isad", true);
    localStorage.setItem("userName", jwt.userName);
  } else {
    localStorage.setItem(tokenKey, jwt.access_token);
    // localStorage.setItem("tokenApp",jwtApp.access_token );
    localStorage.setItem("isad", false);
    localStorage.setItem("userName", jwt.userName);
  }



}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
  try {
    const userName = localStorage.getItem("userName");

    return userName;

  } catch (ex) {

    return null;
  }
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt
};



// WEBPACK FOOTER //
// ./src/services/authService.js